import { render, staticRenderFns } from "./writeOff.vue?vue&type=template&id=30a4021c&scoped=true&"
import script from "./writeOff.vue?vue&type=script&lang=js&"
export * from "./writeOff.vue?vue&type=script&lang=js&"
import style0 from "./writeOff.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./writeOff.vue?vue&type=style&index=1&id=30a4021c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4021c",
  null
  
)

export default component.exports